module.exports = {
  "country": "LT",
  "artist": "Donny Montell",
  "song": "I've Been Waiting for this Night",
  "year": "2016",
  "place": "9",
  "spotify": "2FuzZfIyH3Hkr84RjV0Hvd"
};